import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractCrudService } from '../../service/abstract.crud.service';
import { ProcedimentoAgendaPk } from './pks/procedimento-agenda-pk';

@Injectable({
  providedIn: 'root'
})
export class ProcedimentoAgendaService extends AbstractCrudService {

  protected getBaseUrlPrivate(): string {
    return super.getBaseUrlPrivate() + 'procedimentoAgenda';
  }

  protected getBaseUrlPublic(): string {
    return super.getBaseUrlPublic() + 'procedimentoAgenda';
  }

  // listarAgendaDoProcedimento(idProcedimento: number): Observable<any> {
  //   return this.http.get(`${this.getBaseUrlPublic()}/agenda/${idProcedimento}`);
  // }

  listarMedicosDaAgendaDoProcedimento(idFilial: number, idProcedimento: number, idPlanoSaude: number): Observable<any> {
    return this.http.get(`${this.getBaseUrlPublic()}/agenda/medicos/filial/${idFilial}/procedimento/${idProcedimento}/planoSaude/${idPlanoSaude}`);
  }

  listarProcedimentoAgendaComProjecao(idProcedimento: number | undefined, idMedico: number | undefined, diaSemana: number | undefined): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/agenda/procedimento/${idProcedimento}/medico/${idMedico}/diaSemana/${diaSemana}/comProjecao`);
  }

  removerAgendaProcedimento(pk: ProcedimentoAgendaPk): Observable<any> {
    return this.http.post(`${this.getBaseUrlPrivate()}/removerAgendaProcedimento`, pk);
  }

  removerListaAgendaProcedimento(listaPksEntities: Array<ProcedimentoAgendaPk>): Observable<any> {
    return this.http.post(`${this.getBaseUrlPrivate()}/removerListaAgendaProcedimento`, listaPksEntities);
  }

  criarAgenda(entity: Object): Observable<Object> {
    return this.http.put(`${this.getBaseUrlPrivate()}/criarAgenda`, entity);
  }

  atualizarAgenda(entity: Object): Observable<Object> {
    return this.http.put(`${this.getBaseUrlPrivate()}/atualizarAgenda`, entity);
  }

  procurarAgendaPorPk(entityId: Object): Observable<any> {
    return this.http.post(`${this.getBaseUrlPrivate()}/procurarPorId`, entityId);
  }

  listarFiliaisPorProcedimento(idProcedimentoConsulta: number): Observable<any> {
    return this.http.get(`${this.getBaseUrlPublic()}/filtroFiliaisPorProcedimento/${idProcedimentoConsulta}`);
  }
}
